export default __webpack_public_path__ + "static/media/Archpriest's Fauld of the Nine Springs.81a5ea52.jpg";